<template>
  <div v-show="addShow" v-dragDiv class="issueadd">
    <div class="addTitle moveDragDiv">
      <span>创建批注</span>
      <i class="el-icon-close" @click="closeArea"></i>
    </div>
    <div class="nav">
      <notationAdd  ref="notationAdd" type="modeldwg" @closeAdd="closeAdd" />
    </div>
  </div>
</template>

<script>
import notationAdd from "@/views/question/notationAdd.vue";
export default {
  components: { notationAdd },
  data() {
    return {
      addShow: false
    }
  },
  methods: {
    showAdd() {
      Monge.Map.CloudNotation.clear();
      Monge.Map.Annotation.clear();
      Monge.Map.Annotation.deactive()
      this.$message.success("请绘制云线");
      this.AddCloudNot()
    },
    AddCloudNot() {
      const Annotation = Monge.Map.Annotation;
      Annotation.active({
        color: 0xff0000,
        fontSize: 200,
        mode: Annotation.AnnotationType.RECTANGLE,
        callback: (type, data) => {
          if (type === Monge.CallbackType.ANNOTATION_ITEM_DONE) {
            Annotation.setAllItemDone();
            // this.addpanel = true;
            // 画完云线 弹出创建页面
            this.addShow = true;
            // this.$nextTick(()=>{
            //   this.$refs.notationAdd.init()
            // })

            // 单个批注标记完成
          } else if (type === Monge.CallbackType.ANNOTATION_ITEM_DONE) {
            // 所有批注标记完成
          } else if (type === Monge.CallbackType.DONE) {              
            // 批注已经绘制完成
            this.addShow = false;
            this.$nextTick(() => {
              this.$refs.notationAdd.screenCaptureByBox(data)
            })
          }
        }
      });
    },
    closeAdd(logo) {
      if (logo == 'list') { // 打开问题列表
        this.$parent.$refs.listNotation.openList()
      } else {
        this.addShow = false;
      }
    },
    closeArea() {
      Monge.Map.CloudNotation.clear();
      Monge.Map.Annotation.clear();
      Monge.Map.Annotation.deactive()
      this.addShow = false
    }
  }
}
</script>

<style lang="scss" scoped>
.issueadd{
  position: fixed;
  top: 35px;
  left: calc(50% - 380px);
  width: 370px;
  height: calc(100% - 90px);
  max-height: 870px;
  z-index: 15 ;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0px 0px 4px 1px rgba(46, 91, 255, 0.17);
  border-radius: 4px;
  .addTitle{
    cursor: move;
    width: 100%;
    height: 50px;
    padding: 0 15px;
    box-sizing: border-box;
    border-bottom: 1px solid #E8EBEF;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    user-select: none;
    span{
      font-size: 16px;
      font-weight: bold;
    }
    i{
      font-size: 16px;
      cursor: pointer;
    }
  }
  .nav{
    width: 100%;
    height: calc(100% - 50px);
    padding: 10px 0 10px 15px;
    overflow: hidden;
  }
}
</style>
